<template>
  <q-btn-group rounded>
    <date-of-loss-filter-btn
      v-if="isGranted('VIEW_LEGAL_PHRASES')"
      :client-id="clientId"
      :date-of-loss="dateOfLoss"
      :model-value="modelValue"
      :filters="filters"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
    <date-of-loss-filter-btn
      v-if="isGranted('VIEW_LEGAL_PHRASES')"
      :client-id="clientId"
      :date-of-loss="dateOfLoss"
      :model-value="modelValue"
      :filters="filters"
      post-date-of-loss
      @update:modelValue="$emit('update:modelValue', $event)"
    />
    <date-range-picker-btn
      :label="customLabel"
      :model-value="modelValue"
      :color="customColor"
      @update:modelValue="$emit('update:modelValue', $event)"
      ref="dateRangePickerBtn" />
    <q-btn
      v-if="hasValue"
      icon="fa fa-times"
      @click="clear" />
  </q-btn-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { PostFilters, OpenDateRange } from '@/type';
import isGranted from '@/auth/isGranted';
import DateRangePickerBtn from '@/components/form/DateRangePickerBtn.vue';
import DateOfLossFilterBtn from './DateOfLossFilterBtn.vue';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    dateOfLoss: {
      type: String,
      required: true,
    },
    modelValue: Object as () => OpenDateRange,
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
  computed: {
    customLabel(): string {
      if (this.isGranted('VIEW_LEGAL_PHRASES')) {
        return 'Custom';
      }
      return 'Filter by Date';
    },
    hasValue(): boolean {
      return (
        _.isObject(this.modelValue)
        && (
          _.isString(this.modelValue.start)
          || _.isString(this.modelValue.end)
        )
      );
    },
    isCustom(): boolean {
      return (
        _.isObject(this.modelValue)
        && _.isString(this.modelValue.start)
        && _.isString(this.modelValue.end)
      );
    },
    customColor(): string|undefined {
      if (!isGranted('VIEW_LEGAL_PHRASES')) {
        return undefined;
      }
      return this.isCustom ? 'primary' : undefined;
    },
  },
  methods: {
    isGranted,
    clear(): void {
      this.$emit('update:modelValue', {
        start: null,
        end: null,
      });
    },
  },
  components: {
    DateOfLossFilterBtn,
    'date-range-picker-btn': DateRangePickerBtn,
  },
});
</script>
